exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "atomic-pager::part(page-button){--atomic-primary:#c3c3c3}atomic-pager::part(next-button),atomic-pager::part(page-button),atomic-pager::part(previous-button){width:50px;height:50px;border:1px solid #c3c3c3}atomic-pager::part(active-page-button){--atomic-background:#042358;--atomic-primary:#fff;--atomic-on-background:#fff}atomic-pager::part(active-page-button):focus-visible{background-color:var(--atomic-background)}atomic-pager::part(next-button),atomic-pager::part(previous-button){--atomic-primary:#000}atomic-pager::part(buttons){gap:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-621cb218","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/hcxf/atomic-pagination.vue
// module id = 565
// module chunks = 0 1